import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';

import { Button, ErrorState } from '@/components/ui';

/** `errorElement` for every route: a failed lazy chunk or loader must not blank the shell. */
export function RouteErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  if (isRouteErrorResponse(error)) {
    return (
      <ErrorState
        title={`Erro ${String(error.status)}`}
        description={
          typeof error.data === 'string' && error.data !== ''
            ? error.data
            : 'Não foi possível abrir esta página.'
        }
        action={
          <Button
            variant="secondary"
            onClick={() => {
              void navigate('/');
            }}
          >
            Voltar ao início
          </Button>
        }
      />
    );
  }

  return (
    <ErrorState
      error={error}
      title="Não foi possível abrir esta página"
      onRetry={() => {
        window.location.reload();
      }}
      retryLabel="Recarregar"
    />
  );
}
